export default __webpack_public_path__ + "static/design_team-7adeec62cbfbd85d528e36e34868a2fe.jpg";